module.exports = __webpack_public_path__ + "static/media/img-quem-somos1.c6c2b970.png";